export default __webpack_public_path__ + "static/media/newsroom.b07da2ae.jpg";